var _style, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Dotsload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 20",
    width: "100%",
    height: "auto",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Chargement",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .dot {\n      fill: #333;\n      animation: blink 1.4s infinite;\n    }\n    .dot:nth-child(1) {\n      animation-delay: 0s;\n    }\n    .dot:nth-child(2) {\n      animation-delay: 0.2s;\n    }\n    .dot:nth-child(3) {\n      animation-delay: 0.4s;\n    }\n    @keyframes blink {\n      0% { opacity: 0.2; }\n      20% { opacity: 1; }\n      100% { opacity: 0.2; }\n    }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 20,
    cy: 10,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 60,
    cy: 10,
    r: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 100,
    cy: 10,
    r: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dotsload);
export default __webpack_public_path__ + "static/media/3dotsload.8c7e2de5301f463eab21f8992377097d.svg";
export { ForwardRef as ReactComponent };